<template>

    <div class="w-full h-full flex flex-col  gap-2 p-4 bg-[var(--fundoApp)] rounded-[10px] bg-opacity-[0.55] text-[var(--text)]">
        <div class="w-full flex gap-2">
            
            <AppButton :visibility="true" emitType="select" left_icon="fa-solid fa-circle-plus fa-2xl"
                @select="create_entity(data.entity)" :font_size="12" style="background-color: var(--button); color: var(--label);" :text="'novo/a ' + data.entity" />

            <AppButton :visibility="true" emitType="select" style="background-color: var(--button); color: var(--label);"  @select="list_entities(data.entity)" :font_size="12"
                :color="!show_entity_list ? '#9797EF' : '#ff9b05'"
                :text="!show_entity_list ? 'Listar ' + data.entity + 's' : 'Adicionar items'" />

            <!-- <h3 class="text-[#ff9b05]">Produto</h3> -->
            <AppButton class="self-end text-[var(--text)] ml-auto" v-bind:visibility="true"
                left_icon="fa-regular fa-circle-xmark fa-xl" emitType="close" @click="close" @close="close" :width=23 :height=23 />
        </div>

        <div class="up_container flex gap-2 ">
            <div class="left flex flex-col gap-2">

                <AppButton :visibility="true" emitType="select" @select="clear_inputs" :font_size="12" style="background-color: var(--button); color: var(--label);"
                    text="Limpar" />

                <div v-if="entity_is_null()"
                    class="flex flex-col gap-2 p-4 bg-[#5D5D98] rounded-[10px] bg-opacity-[0.55] min-w-64">
                    <h3 class="text-[#ff9b05]">Criar {{ data.entity }}</h3>
                    
                    <div class="flex gap-2">
                        <label for="stockCheck">Stock</label>
                        <input @click="checkStck(models_copy[data.entity].stock)" id="stockCheck" type="checkbox" v-model="models_copy[data.entity].stock">
                    </div>

                    <div class="g-data_set_class">
                        <div class="g-data_set">
                            <div style="min-width: 142px">Armazem:</div>
                                <div style="color: #ff9b05">
                                    {{ extraData.armazem?.nome ?? 'N/A' }}
                                </div>
                            <div class="pl-5 flex items-center h-full">
                                <button @click="submitCustomType('armazem')" >
                                <Icon class="g-edit-icon" icon="lucide:edit" />
                                </button>
                            </div>
                        </div>
                        
                        <div class="g-data_set">
                            <div style="min-width: 142px">Moeda:</div>
                                <div style="color: #ff9b05">
                                    {{ cutomTypes.moeda.nome ?? 'N/A' }}
                                </div>
                            <div class="pl-5 flex items-center h-full">
                                <button @click="submitCustomType('moeda')" >
                                <Icon class="g-edit-icon" icon="lucide:edit" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-if="1" class="flex flex-col text-[var(--text)]">
                        <label class="capitalize" for="localizacao">{{ 'Localização' }}:</label>
                        <input id="localizacao" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] lg:max-w-40"
                            type="text" v-model="extraData.localizacao"
                            :disabled="models_copy[data.entity].stock == true "
                            placeholder="ex. 1.2.3..." >
                    </div>
                    
                    <div v-for="(value, key) in models_copy[data.entity]" :key="key">
                        
                        <div v-if="!contains_id(key)" class="flex flex-col text-[var(--text)]">
                            <label class="capitalize" :for="key">{{ key }}:</label>
                            <input class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] lg:max-w-40"
                                :type="getInputType(key, value)" v-model="models_copy[data.entity][key]"
                                :disabled="onlyReadInputs2.includes(key)"
                                :placeholder="key"
                                :class="{ 'text-[var(--text)]': onlyReadInputs2.includes(key) }">
                        </div>
                    </div>

                    <div v-if="!isFaturacao" class="set_data_container rounded-[10px] flex flex-col gap-2 p-2 bg-[#5d5d988c] ">
                        <div v-for="(value, key) in set_data_copy" :key="key">
                            <div class="ser_data flex gap-2 ">
                                <label class="capitalize" for="Iva">{{ key }}:</label>
                                <div class="text-[#ff9b05] min-w-[80px]">
                                    {{ value.nome ? value.nome : value.numero }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div v-else class="set_data_container rounded-[10px] flex flex-col gap-2 p-2 bg-[#5d5d988c] ">
                        <div >
                            <div class="ser_data flex gap-2 ">
                                <label class="capitalize" for="Iva">Moeda:</label>
                                <div class="text-[#ff9b05] min-w-[80px]">
                                    {{ cutomTypes.moeda.nome ?? 'N/A' }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="isFaturacao" class="grid grid-cols-2 gap-1">
                        <div class="mb-1">
                            <AppButton v-bind:visibility="true" :font_size="12" color="#ff9b05"
                                left_icon="fa-solid fa-pen-to-square" text="moeda" emitType="select"
                                class="capitalize" 
                                @click="submitCustomType('moeda')"
                                />
                        </div>
                    </div> -->

                    <div v-if="entity_is_null() && !isFaturacao" class="grid grid-cols-2 gap-1">
                        <div v-for="(value, key) in types" :key="key" class="mb-1">
                            <AppButton v-bind:visibility="true" :font_size="12" color="#ff9b05"
                                left_icon="fa-solid fa-pen-to-square" :text="key" emitType="select"
                                @select="open_set_generic_table(key)" class="capitalize" />
                        </div>

                    </div>
                    

                </div>



                <div class="flex flex-col gap-2 p-4 bg-[#5D5D98] rounded-[10px] bg-opacity-[0.55]">
                    <div class="flex gap-1">
                        <h3 class='text-[#ff9b05] text-nowrap'>{{  current_edit_entity_name }}</h3>
                        <h3 class="text-nowrap">{{ current_edit_entity_value }}</h3>
                    </div>
                    <div class="flex gap-2">
                        <AppButton v-if="true" v-bind:visibility="true" :font_size="12" style="background-color: var(--button); color: var(--label);"
                            left_icon="fa-solid fa-pen-to-square" text="Equipamentos" emitType="select" 
                            @select="open_generic_table('equipamento')" />
                    </div>
                    <div class="g-data_set_class">
                        <div class="g-data_set">
                            <div style="min-width: 142px">Iva:</div>
                                <div style="color: #ff9b05">
                                    {{ cutomTypes.iva.nome ?? 'N/A' }}
                                </div>
                            <div class="pl-5 flex items-center h-full">
                                <button @click="submitCustomType('iva')" >
                                <Icon class="g-edit-icon" icon="lucide:edit" />
                                </button>
                            </div>
                        </div>
                        <div class="g-data_set">
                            <div style="min-width: 142px">Tipo de artigo:</div>
                                <div style="color: #ff9b05">
                                    {{ extraData.tipoArtigo?.nome ?? 'N/A' }}
                                </div>
                            <div class="pl-5 flex items-center h-full">
                                <button @click="submitCustomType('artigo')" >
                                <Icon class="g-edit-icon" icon="lucide:edit" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-for="(value, key) in models_copy[model_type]" :key="key">
                        <div v-if="key !== 'id'" class="flex flex-col text-[var(--text)]">
                            <label class="capitalize" :for="key">{{ key }}:</label>
                            <input
                                adisabled="/*key === 'total' || key === 'preco' || key === 'valorTotal' || key === 'valorUnitario'*/"
                                :disabled="onlyReadInputs.includes(key)"
                                class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] lg:max-w-40"
                                :class="{ 'text-[var(--text)]': onlyReadInputs.includes(key) }" :type="getInputType(key, value)"
                                v-model="models_copy[model_type][key]" :placeholder="key"
                                @input="handleInputChange(key)" :max="key === 'desconto' ? 1 : null"
                                :min="key === 'desconto' ? 0 : null" :step="key === 'desconto' ? 0.01 : null">
                        </div>
                    </div>


                    

                    <!-- <div v-if="isFaturacao" class="set_data_container rounded-[10px] flex flex-col gap-2 p-2 bg-[#5d5d988c] ">
                        <div >
                            <div class="ser_data flex gap-2 ">
                                <label class="capitalize" for="Iva">Iva:</label>
                                <div class="text-[#ff9b05] min-w-[80px]">
                                    {{ cutomTypes.iva.nome ?? 'N/A' }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="isFaturacao" class="grid grid-cols-2 gap-1">
                        <div class="mb-1">
                            <AppButton v-bind:visibility="true" :font_size="12" color="#ff9b05"
                                left_icon="fa-solid fa-pen-to-square" text="iva" emitType="select"
                                
                                class="capitalize"
                                @click="submitCustomType('iva')"
                                 />
                        </div>
                    </div> -->
                
                    <!-- <AppButton v-if="isFaturacao"
                        v-bind:visibility="true" :font_size="12" color="#9797EF" left_icon="fa-solid fa-pen-to-square"
                        :text="get_dependency_name()" emitType="select" @select="open_dependency_tab(data.entity)" /> -->

                </div>




                
                <!-- <AppButton v-bind:visibility="true" :font_size="12" color="#9797EF"
                    left_icon="fa-solid fa-pen-to-square" text="Serviços" emitType="select"
                    @select="open_generic_table('servico')" /> -->


                <!-- <div class="button-container">
                    <div v-for="(value, key) in types" :key="key" class="button-wrapper">
                        <AppButton v-bind:visibility="true" :font_size="12" color="#ff9b05" left_icon="fa-solid fa-pen-to-square" :text="key" emitType="select" @select="open_generic_table(key)" />
                    </div>
                </div> -->
                <button class="bg-[#006698] py-2 text-white rounded-[10px] lg:max-w-40" @click.prevent="add_data">{{
                    data_create ? 'Adicionar' : 'Atualizar' }}</button>


                <button v-if="!data_create" class="bg-[#a82222] py-2 text-white rounded-[10px] lg:max-w-40"
                    @click.prevent="delete_data">eliminar</button>

                <!-- <button v-if="this?.data[this.data.entity]?.dependency"
                    class="bg-[#ff9b05] text-white py-2 rounded-[10px] lg:max-w-40" @click.prevent="return_to_tab">
                    Salvar e Voltar</button> -->

                <!-- <AppButton v-if="!entity_is_null() && !isFaturacao"
                    v-bind:visibility="true" :font_size="12" color="#9797EF" left_icon="fa-solid fa-pen-to-square"
                    :text="get_dependency_name()" emitType="select" @select="open_dependency_tab(data.entity)" /> -->

                <AppButton v-if="!isFaturacao"
                    v-bind:visibility="true" :font_size="12" :color="entity_is_null() ? '#7B7B99' : '#9797EF'"
                    :left_icon="entity_is_null() ? 'fa-solid fa-lock' : 'fa-solid fa-arrows-turn-right'"
                    :text="get_dependency_name()" emitType="select" @select="open_dependency_tab(data.entity)" />

            </div>

            <div v-if="!show_generic_table" class="right flex flex-col gap-2 p-2 w-full h-full">
                <AppTable :visibility="true" :show="true" :table_data="table_data" :table_title="table_title"
                    @row-clicked="select_upTable_data" :show_multiSelect="false" :page_display="5" @close="getFaturacao" />
            </div>

            <div v-else class="right flex flex-col gap-2 p-2 w-full h-full">
                <AppTable visibility="true" :show="show_generic_table" :table_data="generic_table_data"
                    :table_title="generic_table_title" @row-clicked="select_generic_data" :show_multiSelect="false"
                    :page_display="5" @close="show_generic_table = false" />
            </div>
        </div>

        <div class="down_container flex gap-2">
            <div class="left flex flex-col gap-2 ">
                <AppInfoCard :data="infoCard_data" :title="'informação do/a ' + data.entity" />
                <!-- chamar component infoCard -->
            </div>

            <div v-if="!show_entity_list" class="right flex flex-col gap-2 p-2 w-full h-full">
                <AppTable :visibility="true" :show="!show_entity_list" :table_data="downTable_data"
                    :table_title="current_table_entity_route + ' ' + data.entity" @row-clicked="select_downTable_data"
                    :show_multiSelect="false" :page_display="5" @close="null" />
            </div>

            <div v-if="show_entity_list" class="right flex flex-col p-2 w-full h-full">
                <AppTable :visibility="true" :show="show_entity_list" :table_data="entities" :table_title="data.entity"
                    @row-clicked="select_entity_data" :show_multiSelect="false" :page_display="5" @close="null" />
            </div>

        </div>
    </div>

</template>


<script>

    import axios from 'axios';
    import AppTable from '@/components/tables/table.vue'
    import AppButton from '@/components/updated/button.vue'
    import AppAddressMap from '@/components/addressMap.vue'
    import AppInfoCard from '@/components/infoCard_final.vue'
    import { toast } from 'vue3-toastify';

    export default {
        name: 'proposta',
        components: {
            AppButton,
            AppTable,
            AppAddressMap,
            AppInfoCard
        },
        props: {

            data: {
                type: Object,
                default: {}
            },

            models: {
                type: Array,
                default: []
            },
            types: {
                type: Object,
                default: {}
            },
            set_data: {
                type: Object,
                default: {}
            },
            fornecedor_id: {
                type: Number,
                default: 0
            },
            set_id: {
                type: Object,
                default: {}
            },
            owners: {
                type: Object,
                default: {}
            },

            tab_mode: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                isFaturacao: false,
                cutomTypes:{
                    moeda:{
                        id:0,
                        nome:'N/A'
                    },
                    iva:{
                        id:0,
                        nome:'N/A'
                    },
                },
                onlyReadInputs: ['total', 'preco', 'valorTotal', 'stock'], // 'valorUnitario'
                onlyReadInputs2: ['versao'],
                table_title: 'N/A',
                table_data: [],
                extraData: {
                    armazem: {},
                    localizacao: null,
                    tipoArtigo: {},
                    nomeArtigo: null,
                    codigoBarra: null,
                },
                // customData: [],

                models_copy: JSON.parse(JSON.stringify(this.models)),
                set_data_copy: JSON.parse(JSON.stringify(this.set_data)),
                infoCard_data: {
                    nome: '',
                    morada: '',
                    email: '',
                    telefone: '',
                },
                faturacoes: [],

                entity: {},
                entities: [],
                current_table_entity: {},
                current_table2_entity: {},
                current_edit_entity_name: 'Equipamento:',
                current_edit_entity_value: '',
                data_create: true,
                show_entity_list: false,
                equipamentos: [],
                servicos: [],
                upTable_data: [],
                downTable_data: [],
                baseURl: process.env.VUE_APP_URL_BASE,
                model_type: 'equipamento',

                current_table_entity_route: 'item',

                show_generic_table: false,
                generic_table_title: '',
                generic_table_data: [],
            }
        },
        created() {
            console.log("item---", this.item)
            this.getFaturacao()


            // if(this.data.entity == 'faturafornecedor' ){ // || this.data.entity == 'faturacliente'
            if(this.data.entity == 'faturafornecedor'  || this.data.entity == 'faturacliente'){ 
                this.isFaturacao = true
                this.onlyReadInputs.push('subTotal')
                this.onlyReadInputs2 = this.onlyReadInputs2.concat(['subTotal', 'total', 'valorTotalComIva','desconto'])
            }
        },


        methods: {


            getInputType(key, value) {
                return typeof value === 'number' ? 'number' : 'text';
            },


            checkStck(status){

                // alert(status)
                if(!status){
                    this.extraData.localizacao = null
                }
            },


            async submitCustomType(type){
                
                    this.show_generic_table = true;
                    this.generic_table_title = type;
                           
                    if (type == 'armazem'){
                        this.generic_table_data = await this.getCustomType(type,false);
                    }else{
                        this.generic_table_data = await this.getCustomType(type);
                    }
                        
                
            },

            async getCustomType(type,withTp=true){ 
                // let customized = 'tp'+type.charAt(0).toUpperCase() + type.slice(1);
                let customized = type;

                if(withTp){
                    customized = 'tp'+type;
                }

                try {
                    const res = await axios.get(`${this.baseURl}/api/v1/${customized}/?custom=True`);
                    return res.data.data;
                } catch (error) {
                    console.error('Error getting data:', error);
                }

            },

            

            async get_datas() {
                const isEmptyObject = obj => Object.keys(obj).length === 0 && obj.constructor === Object;
                const equipamentos = await this.select_all(`${this.baseURl}/api/v1/equipamento/?custom=True&fromFornecedor=1`);
                const servicos = [];
                this.equipamentos = equipamentos?.sort((a, b) => a.id - b.id)
                this.servicos = servicos?.sort((a, b) => a.id - b.id)
                this.table_title = 'Equipamentos'
                this.table_data = equipamentos
                if (this.model_type == 'equipamento')
                    this.upTable_data = [...this.equipamentos]
                else
                    this.upTable_data = [...this.servicos]




            },

            async getFaturacao() {
                const isEmptyObject = obj => Object.keys(obj).length === 0 && obj.constructor === Object;
                const faturacoes = await this.select_all(`${this.baseURl}/api/v1/faturafornecedor/?custom=True&&fornecedor_id=${this.fornecedor_id}`);
                this.table_title = 'Faturas'
                this.table_data = faturacoes
                const servicos = [];
                this.faturacoes = faturacoes?.sort((a, b) => a.id - b.id)
                this.servicos = servicos?.sort((a, b) => a.id - b.id)

                if (this.model_type == 'faturacao')
                    this.upTable_data = [...this.faturacoes]
                else
                    this.upTable_data = [...this.servicos]




            },

            async add_data() {

                const isEmptyObject = obj => Object.keys(obj).length === 0 && obj.constructor === Object;

                for (let key in this.set_data_copy) {

                    if (this.set_id.hasOwnProperty(key)) {
                        this.models_copy[this.data.entity][this.set_id[key]] = this.set_data_copy[key].id

                    }

                }

                if (this.data_create) {
                    if (isEmptyObject(this.current_table_entity)) {
                    console.log("Models: ", this.models_copy[this.data.entity])
                        toast("Selecione um Equipamento!", {
                            "theme": "auto",
                            "type": "warning",
                            "position": "top-center",
                            "autoClose": 1000,
                        });
                        return
                    }


                    if (isEmptyObject(this.entity)) {

                        if (this.data.entity == 'orcamento' && this.models_copy[this.data.entity].titulo == '') {
                            toast("O titulo é obrigatório!", {
                                "theme": "auto",
                                "type": "warning",
                                "position": "top-center",
                                "autoClose": 1000,
                            });
                            return
                        }

                        let finalEntityData = this.models_copy[this.data.entity];


                        if (finalEntityData.stock == false) {
                            finalEntityData.stock = 0
                        }else{
                            finalEntityData.stock = 1
                        }



                        if (this.isFaturacao) {
                            finalEntityData.tpMoeda_id = this.cutomTypes.moeda.id
                            // console.log("finalEntityData:", finalEntityData);
                            
                        }
                        // let lowerEntitty = ''
                        // this.data.entity = this.data.entity == 'faturaCliente' ? 'faturacliente' : this.data.entity
                        const res = await this.create(finalEntityData, `${this.baseURl}/api/v1/${this.data.entity}/registrar/`);
                        this.entity = JSON.parse(JSON.stringify(res))

                        // if (this?.data[this.data.entity]?.dependency) {
                        //     console.log("dependency:", this.data[this.data.entity].dependency)
                        //     this.$emit('dependency_created', this.data.entity, this.entity)

                        // }

                    }
                    this.copyValues();


             

                    let finalItemEntityData = this.models_copy['db_model'];

                    if (this.isFaturacao) {
                        finalItemEntityData.tpIva_id = this.cutomTypes.iva.id
                        finalItemEntityData.faturaCliente_id = this.entity.id
                        finalItemEntityData.extraData = this.extraData
                        console.table("finalItemEntityData:", finalItemEntityData);
                        console.table("entity_id:", this.entity.id);
                        
                        console.log("finalItemEntityData:", finalItemEntityData);
                        
                    }
                    console.log("finalItemEntityData:", finalItemEntityData);
                    
                    const res = await this.create(finalItemEntityData, `${this.baseURl}/api/v1/${this.current_table_entity_route}${this.data.entity}/registrar/`);

                    if (res) {
                        const entity = await this.select(`${this.baseURl}/api/v1/${this.data.entity}/${this.entity.id}/?custom=True`);
                        console.log("entity:", entity)
                        this.infoCard_data = entity
                        this.downTable_data.push(res)

                        toast.success(`Item ${this.data.entity} criado com sucesso!`, {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 1000,
                        });

                    }

                    console.log("create")
                }
                else {

                    console.log("update")
                    this.copyValues();
                    console.log("db_model:", this.models_copy['db_model'])
                    const res = await this.update(`${this.baseURl}/api/v1/${this.current_table_entity_route}${this.data.entity}/editar/${this.current_table2_entity.id}/`, this.models_copy['db_model']);
                    if (res) {
                        const entity = await this.select(`${this.baseURl}/api/v1/${this.data.entity}/${this.entity.id}/`);
                        console.log("entity:", entity)
                        this.infoCard_data = entity
                        this.downTable_data.find((item, index) => {
                            if (item.id === res.id) {
                                this.downTable_data[index] = res;
                                return true;
                            }
                        });
                        toast.success(`Item ${this.data.entity} atualizado com sucesso!`, {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 1000,
                        });
                    }
                    this.clear_inputs();

                }



                //this.clear_inputs();
            },

            async select_upTable_data(item) {
                //this.clear_inputs();
                this.current_edit_entity_name = 'Equipamento:';
                this.current_edit_entity_value = item.nome;
                this.calc_total()
                this.models_copy[this.model_type] = JSON.parse(JSON.stringify(this.models[this.model_type]))
                this.current_table_entity = {}
                this.current_table2_entity = {}
                this.data_create = true

                this.current_table_entity = JSON.parse(JSON.stringify(item))
                console.log("current_table_entity:", this.current_table_entity)
                console.log("upTable_data:", item)

                if (this.isFaturacao) {

                    item?.compra ? this.models_copy[this.model_type].valorUnitario = item.compra : 0
                } else {

                    if (this.data.entity != 'proposta') {
                        item?.compra ? this.models_copy[this.model_type].preco = item.compra : 0

                    } else if (this.data.entity == 'orcamento') {
                        item?.quantidade ? this.models_copy[this.model_type].quantidade = item.quantidade : 1
                    }
                }



                this.models_copy[this.model_type].quantidade = 1

                this.calc_total()
            },

            async select_downTable_data(item) {
                //this.infoCard_data = item
                const res = await this.select(`${this.baseURl}/api/v1/${this.current_table_entity_route}${this.data.entity}/${item.id}/`);
                if (res) {
                    this.clear_inputs();
                    this.current_table2_entity = JSON.parse(JSON.stringify(res))
                    this.current_edit_entity_name = 'Item '+this.data.entity+'ID:';
                    this.current_edit_entity_value = res.id;
                    this.data_create = false;
                    if (this.isFaturacao) {
                        res?.compra ? this.models_copy[this.model_type].valorUnitario = res.compra : 0
                    } else if (this.data.entity == 'orcamento') {
                        res?.quantidade ? this.models_copy[this.model_type].quantidade = res.quantidade : 1
                        res?.preco ? this.models_copy[this.model_type].preco = res.preco : 0
                        res?.desconto ? this.models_copy[this.model_type].desconto = res.desconto : 0
                    } else {
                        res?.compra ? this.models_copy[this.model_type].preco = res.compra : 0
                        res?.desconto ? this.models_copy[this.model_type].desconto = res.desconto : 0
                        res?.quantidade ? this.models_copy[this.model_type].quantidade = res.quantidade : 1
                    }
                }

                console.log("downTable_data:", item)
                console.log('Models copy:', this.models_copy)
            },

            async select_data(item) {
                console.log('table_item:', item)

            },

            async delete_data() {
                const res = await this.remove(`${this.baseURl}/api/v1/${this.current_table_entity_route}${this.data.entity}/eliminar/${this.current_table2_entity.id}/`);
                if (res) {
                    const entity = await this.select(`${this.baseURl}/api/v1/${this.data.entity}/${this.entity.id}/`);
                    console.log("entity:", entity)
                    this.infoCard_data = entity
                    this.downTable_data = this.downTable_data.filter((item) => item.id !== this.current_table2_entity.id);
                    toast.success(`Item ${this.data.entity} eliminado com sucesso!`, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 1000,
                    });
                }


                this.clear_inputs();
            },

            clear_inputs() {
                this.models_copy = JSON.parse(JSON.stringify(this.models))
                this.current_table_entity = {}
                this.current_table2_entity = {}
                this.data_create = true

                this.current_edit_entity_name = 'Equipamento:';
                this.current_edit_entity_value = '';
            },

            close() {
                this.$emit('close')
            },

            updateTipo(event) {
                console.log("choice:", event.target.value)
                // this.item['tipo'] = event.target.value;
                console.log(this.item['tipo'])
            },


            save_items() {
                this.$emit('saved_items', this.items)
            },

            async create(data, url) {
                try {
                    const res = await axios.post(url, data);
                    return res.data.data;
                } catch (error) {
                    console.error('Error getting data:', error);
                }
            },

            async select(url) {
                try {
                    const res = await axios.get(url);
                    return res.data.data;
                } catch (error) {
                    console.error('Error getting data:', error);
                }
            },

            async select_all(url) {
                try {
                    const res = await axios.get(url);
                    return res.data.data;

                } catch (error) {
                    console.error('Error getting data:', error);
                }

            },

            async update(url, data) {

                try {
                    const res = await axios.put(url, data);
                    console.log('Data successfully updated:', res.data);
                    return res.data.data;

                } catch (error) {
                    console.error('Error posting data:', error);
                }
            },

            async remove(url) {
                // console.log("Data:", data.id)
                try {
                    await axios.delete(url);
                    return true;
                } catch (error) {
                    console.error('Error deleting data:', error);
                }
            },

            open_generic_table(key) {
                console.log("open_generic_table:", key)
                this.show_generic_table = false;
                this.model_type = key
                if (key == 'equipamento') {
                    this.current_table_entity_route = 'item'
                    this.upTable_data = [...this.equipamentos]
                    this.get_datas()
                }
                else {
                    this.current_table_entity_route = 'servico'
                    this.upTable_data = [...this.servicos]
                }
            },

            create_entity(entity) {
                this.show_entity_list = false;
                this.entity = {}
                this.clear_inputs()
                this.set_data_copy = JSON.parse(JSON.stringify(this.set_data))
                this.resetDependencies()
                this.downTable_data = []
                this.infoCard_data = {
                    nome: '',
                    morada: '',
                    email: '',
                    telefone: '',
                },

                    console.log("create entity:", entity)
            },

            async list_entities(entity) {
                this.show_entity_list = !this.show_entity_list;

                if (this.show_entity_list) {

                    const res = await this.select_all(`${this.baseURl}/api/v1/${entity}/?custom=True`);
                    if (res) {
                        if (entity == 'orcamento') {
                            this.entities = res.map(item => {
                                return {
                                    versao: item.versao,
                                    cliente: item.cliente,
                                    subCliente: item.subCliente,
                                    localInstalacao: item.localInstalacao,
                                    MIDIAccessoeda: item.Moeda,
                                    Total: item.total,
                                    Iva: item.Iva,
                                    Desconto: item.desconto,
                                    TotalFinal: item.totalFinal,
                                }
                            })


                        } else {

                            this.entities = res
                        }

                    }


                    console.log("list entity:", entity)
                }
            },

            close() {
                this.$emit('close')
            },

            handleInputChange(key) {
                if (key == 'quantidade' || key == 'desconto' || key == 'preco') {
                    this.calc_total();
                }
            },

            calc_total() {

                if (this.data.entity == 'proposta') {
                    return
                }
                // if (this.models_copy[this.model_type].desconto > 1) {
                //     this.models_copy[this.model_type].desconto = 1
                //     return
                // }

                if (this.isFaturacao) {
                    if (this.models_copy[this.model_type].valorUnitario == undefined) {
                        return
                    }

                } else {
                    if (this.models_copy[this.model_type].quantidade == undefined || this.models_copy[this.model_type]?.preco == undefined) { // || this.models_copy[this.model_type]?.valorUnitario == undefined
                        return
                    }
                }


                // alert("calc_total")
                if (this.models_copy[this.model_type].desconto == undefined) {
                    this.models_copy[this.model_type].desconto = 0
                }


                let preco = this.models_copy[this.model_type].preco || this.models_copy[this.model_type].valorUnitario



                const quantidade = this.models_copy[this.model_type].quantidade
                const desconto = this.models_copy[this.model_type].desconto
                let subtotal = 0
                let total = 0
                subtotal = preco * quantidade

                total = ((quantidade * preco) - desconto)

                if (this.isFaturacao) {
                    this.models_copy[this.model_type].valorTotal = total
                    this.models_copy[this.model_type].subTotal = subtotal
                } else {
                    this.models_copy[this.model_type].total = total
                }
            },

            copyValues() {
                Object.keys(this.models_copy['db_model']).forEach((key) => {
                    if (this.models_copy[this.model_type][key] !== undefined) {
                        this.models_copy['db_model'][key] = this.models_copy[this.model_type][key];
                    }
                });


                Object.keys(this.models_copy['db_model']).forEach((key) => {
                    if (key.toLowerCase().includes(this.model_type)) {
                        this.models_copy['db_model'][key] = this.current_table_entity.id;
                    }
                    if (key.toLowerCase().includes(this.data.entity)) {
                        this.models_copy['db_model'][key] = this.entity.id;
                    }
                });

            },

            select_entity_data(item) {
                this.infoCard_data = item
            },

            select_generic_data(item) {
                console.log("item selected:", item)
                

                this.set_data_copy[this.generic_table_title] = item;
                this.show_generic_table = false;

                if(this.generic_table_title == 'moeda'){
                    this.cutomTypes.moeda = item
                }
                else if(this.generic_table_title == 'iva'){
                    this.cutomTypes.iva = item
                }
                else if(this.generic_table_title == 'armazem'){
                    this.extraData.armazem = item
                }
                else if(this.generic_table_title == 'artigo'){
                    this.extraData.tipoArtigo = item
                }
                


                console.log('CUSTOM TYPES:', this.cutomTypes);
                


                for (let key in this.set_data_copy) {

                    if (this.set_id.hasOwnProperty(key)) {
                        this.models_copy[this.data.entity][this.set_id[key]] = this.set_data_copy[key].id

                    }




                }
            },

            open_set_generic_table(key) {
                this.show_generic_table = true;
                this.generic_table_title = key;
                this.generic_table_data = this.types[key];
               

            },

            entity_is_null() {
            
                const isEmptyObject = obj => Object.keys(obj).length === 0 && obj.constructor === Object 

                return isEmptyObject(this.entity)
            },
            contains_id(key) {
                return key.toLowerCase().includes('id') || key.toLowerCase() == 'stock'
            },

            return_to_tab() {
                if (this?.data[this.data.entity]?.dependency) {
                    console.log("dependency:", this.data[this.data.entity].dependency)
                    this.$emit('dependency_created', this.data.entity, this.entity)

                }

            },

            get_dependency_name() {
                if (this.data.entity == 'orcamento') {
                    return 'Faturação'
                }
                else if (this.data.entity == 'proposta') {
                    return 'Orçamento'
                }
                else {
                    return 'Pedido'
                }
            },

            open_dependency_tab() {
                if(this.entity_is_null()){
                    toast("Cria o/a "+this.data.entity+"!", {
                        "theme": "auto",
                        "type": "warning",
                        "position": "top-center",
                        "autoClose": 1000,
                    });
                    return
                }
                if (this.data.entity == 'orcamento') {
                    this.$emit('open_dependency_tab', 'faturacao', this.entity)
                }
                else if (this.data.entity == 'proposta') {
                    this.$emit('open_dependency_tab', 'orcamento',this.entity )
                }
                else if (this.data.entity == 'faturacao') {
                    this.$emit('open_dependency_tab', 'pedido', this.entity)
                }
            },

            resetDependencies() {
                const keysToReset = ['pedido', 'orcamento', 'proposta'];
                keysToReset.forEach(key => {
                    if (this.set_data_copy.hasOwnProperty(key)) {
                        this.set_data_copy[key] = { id: 0, numero: 'N/A' };
                    }
                });
            }

        },

        watch: {

             'this.models_copy[data.entity].stock': {
                handler(newVal) {
                    alert('changed')
                    if (this.models_copy[this.data.entity].stock == 1) {
                        this.extraData.localizacao = null
                    }
                },
                deep: true
            },

            data: {
                handler() {
                    if (!this.tab_mode) {

                        this.clear_inputs()
                        this.set_data_copy = JSON.parse(JSON.stringify(this.set_data))
                    }
                },
                deep: true
            },
            set_data: {
                handler() {
                    if (this.tab_mode) {
                        
                        
                        if (this.set_data['pedido']) {
                            this.set_data_copy['pedido'] = this.set_data['pedido']
                        }
                        else if(this.set_data['orcamento']){
                            this.set_data_copy['orcamento'] = this.set_data['orcamento']
                        }
                        else if(this.set_data['proposta']){
                            this.set_data_copy['proposta'] = this.set_data['proposta']
                        }
                    }
                },
                deep: true
            }



        },
    }


</script>





<style scoped>
.button-container {
    display: flex;
    flex-wrap: wrap;

    gap: 10px;
    /* Adjust the gap as needed */
}

/* .button-wrapper {
    flex: 1 1 calc(50% - 4.5px);
    max-width: calc(50% - 4.5px);
} */
</style>
